import SideContainerAnimated from "../SideContainer"
import SideForm from "../SideForm"
import { 
    removeMaskCep, 
    removeMaskPhone, 
    removeMaskTaxpayerId 
} from "../../utils/removeMask"
import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { IFormAddClient } from "./interface"
import { 
    BoxInputs,
    ContainerInputCity, 
    ContainerInputUf, 
    Fieldset, 
    FlexBox, 
    RadioButtonContainer, 
    RadioButtonContent, 
    RadioButtonDescription, 
    RadioButtonForm, 
    RadioButtonRow 
} from "./style"
import * as Yup from "yup";
import InputMasked from "react-input-mask";
import Person from "../../assets/icons/person.svg";
import { initValueAddClient } from "../../utils/initialValuesForms/addClient"
import { postBlock } from "../../service/postBlock"
import { useSelector } from "react-redux"
import { cepObject } from "../../service/cepDetail"
import { toastCreate, toastUpdate } from "../../utils/notifications/toast"
import { translateMessageError } from "../../utils/translate/messageErrors"
import LegendFormForm from "../LegendForm"
import Input from "../Input"
import LegendForm from "../LegendForm"
import { handleCepDetailResult } from "../../utils/handleCepDetail"
import { notifysFieldsForm } from "../../utils/notifications/notifyForm"
import ErrorMessage from "../ErrorMessage"
import Button from "../Button"
import { searchForErrors } from "../../hooks/searchForErros"
import { openModal } from "../../helpers/modalFunctions"
import { CepDetailInterface } from "../../service/interfaces/cepDetail"
import ContainerFormSide from "../ContainerFormSide"

const FormAddClient = ({
    isVisible,
    setRefresh,
    setVisible
}: IFormAddClient
): React.ReactElement => {
    const login = useSelector((state: {login: any}) => state.login);
    const [cepDetail, setCepDetail] = useState<CepDetailInterface>(cepObject);
    const [clientType, setClientType] = useState(0);
    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);
    
    const formValidationWithYup = Yup.object().shape({
        firstName: Yup.string().required(),
        lastName: Yup.string().required(),
        email: Yup.string().required(),
        phone: Yup.string().required(),
        cep: Yup.string().required(),
        city: Yup.string().required(),
        uf: Yup.string().min(2).max(2).required(),
        address: Yup.string().required(),
        district: Yup.string().required(),
        number: Yup.string().required(),
        complement: Yup.string().nullable(true),
    });

    const submitForm = async (values: any ): Promise<void> => {
        const taxPayerId = removeMaskTaxpayerId(values.document)
        const cep = removeMaskCep(values.cep)
        let phone = removeMaskPhone(values.phone)

        const {
            isError, 
            loading, 
            block
        } = await postBlock("/buyer", {
            buyerbranchId: login.user.branchsId,
            buyerOwnerId: login.user.branchs.sellerOwner100PayId,
            "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
            sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
            firstName: values.firstName,
            lastName: values.lastName,
            taxpayerId: taxPayerId,
            email: values.email,
            phoneNumber: phone,
            addressLine1: values.address,
            addressLine2: values.number,
            addressLine3: values.complement !== "" ? values.complement : null,
            addressneighborhood: values.district,
            addressCity: values.city,
            addressState: values.uf,
            addressPostalCode: cep,
        })

        successOnSubmit(isError)
        failOnSubmit(isError, block)
    }

    const successOnSubmit = (isError: boolean): void => {
        if(!isError) {
            setErrorOnReturnApi(false);
            toastUpdate("btnSubmit", "success", 3000, "Sucesso")
            setCepDetail(cepObject)
            setRefresh(true)
            openModal("exampleModal");
        } 
    }

    const failOnSubmit = (isError: boolean, block: any): void => {
        if(isError){
            let msg = null

            msg = translateMessageError(
                block.error.message.replaceAll(/\"/g, "'")
            )
            setErrorOnReturnApi(true);
            toastUpdate( "btnSubmit", "error", 4000, 
                msg 
                    ?? "Houve um problema ao criar esse cliente. Contate o suporte."
            )
        }
    }

    return (
        <SideContainerAnimated isVisible={isVisible}>
            <SideForm
                title="Adicionar Cliente"
                icon={Person}
                visible={() => {
                    setVisible("close")
                    setCepDetail(cepObject)
                }}
            >
                <Formik
                    initialValues={initValueAddClient}
                    validationSchema={formValidationWithYup}
                    onSubmit={async (values) => {
                        await submitForm(values)
                    }}
                >
                {({ values, errors, handleChange}) => {
                    values.city = cepDetail.localidade;
                    values.uf = cepDetail.uf;
                    values.district = cepDetail.bairro;
                    values.address = cepDetail.logradouro;

                    return(
                        <ContainerFormSide>
                            <Form>
                                <BoxInputs>
                                    <Fieldset>
                                        <LegendFormForm>Dados Principais</LegendFormForm>
                                        <input type="hidden" value="something"/>
                                        <RadioButtonRow id="first-step">
                                            <RadioButtonForm onClick={() => {
                                                setClientType(0);  
                                            }}>
                                                <RadioButtonContainer>
                                                    <RadioButtonContent isPrimary={clientType === 0}/>
                                                </RadioButtonContainer>
                                                <RadioButtonDescription>Pessoa Física</RadioButtonDescription>
                                            </RadioButtonForm>
                                            <RadioButtonForm onClick={() => {
                                                setClientType(1);
                                            }}>
                                                <RadioButtonContainer>
                                                    <RadioButtonContent isPrimary={clientType === 1}/>
                                                </RadioButtonContainer>
                                                <RadioButtonDescription>Pessoa Jurídica</RadioButtonDescription>
                                            </RadioButtonForm>
                                        </RadioButtonRow>
                                        <Field 
                                            id="firstName" 
                                            name="firstName" 
                                            autoComplete="nope"
                                            className="inputCustom" 
                                            isError={errorOnSubmit && errors.firstName}
                                            placeholder="Primeiro Nome"
                                            as={Input}
                                        />
                                        <Field 
                                            id="lastName" 
                                            name="lastName" 
                                            autoComplete="lastName"
                                            className="inputCustom" 
                                            isError={errorOnSubmit && errors.lastName}
                                            placeholder="Último Nome" 
                                            as={Input}
                                        />
                                        <Field 
                                            id="email" 
                                            name="email" 
                                            autoComplete="nope"
                                            className="inputCustom"
                                            isError={errorOnSubmit && errors.email}
                                            placeholder="Email" 
                                            as={Input}
                                        />
                                        <Field
                                            name="phone"
                                            id="phone" 
                                            autoComplete="nope"
                                            className={`input-masked inputCustom ${errorOnSubmit && errors.phone ? "input-error" : null}`} 
                                            placeholder="Telefone" 
                                            onChange={handleChange}
                                            mask="(99) 99999-9999"
                                            maskChar={null}
                                            as={InputMasked}
                                        />
                                        <Field
                                            name="document" 
                                            id="document" 
                                            autoComplete="document"
                                            className={`input-masked inputCustom ${errorOnSubmit && errors.document ? "input-error" : null}`} 
                                            placeholder={clientType === 0 ? "CPF" : "CNPJ"}
                                            mask={clientType === 0 ? "999.999.999-99" : "99.999.999/9999-99"}
                                            maskChar={null}
                                            onChange={handleChange}
                                            as={InputMasked}
                                        /> 
                                    </Fieldset>
                                    <Fieldset>
                                        <LegendForm>Endereço</LegendForm>
                                        <Field 
                                            name="cep" 
                                            id="cep" 
                                            autoComplete="cep"
                                            className={`input-masked inputCustom ${errorOnSubmit && errors.cep ? "input-error" : null}`} 
                                            placeholder="CEP"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                handleChange(e);
                                            }}
                                            onKeyUp={async () => {
                                                if(values.cep.length === 9){
                                                    handleCepDetailResult(values.cep, setCepDetail);
                                                }
                                            }}
                                            mask="99999-999"
                                            maskChar={null}
                                            as={InputMasked}
                                        />
                                        <FlexBox>
                                            <ContainerInputCity>
                                                <Field 
                                                    id="city" 
                                                    name="city" 
                                                    autoComplete="city"
                                                    className="inputCustom"
                                                    value={values.city}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        handleChange(e);
                                                        setCepDetail({...cepDetail, localidade: e.target.value})
                                                    }}
                                                    isError={errorOnSubmit && errors.city}
                                                    placeholder="Cidade" 
                                                    as={Input}
                                                />
                                            </ContainerInputCity>
                                            <ContainerInputUf>
                                                <Field
                                                    name="uf" 
                                                    id="uf" 
                                                    autoComplete="uf"
                                                    className= {`input-masked inputCustom ${errorOnSubmit && errors.uf ? "input-error" : null}`}
                                                    placeholder="UF"
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        handleChange(e);
                                                        setCepDetail({...cepDetail, uf: e.target.value})
                                                    }}
                                                    value={values.uf}
                                                    mask="aa"
                                                    maskChar={null}
                                                />
                                            </ContainerInputUf>
                                        </FlexBox>
                                        <Field 
                                            id="address" 
                                            name="address"
                                            autoComplete="address"
                                            className="inputCustom"
                                            isError={errorOnSubmit && errors.address}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                handleChange(e);
                                                setCepDetail({...cepDetail, logradouro: e.target.value})
                                            }}
                                            placeholder="Endereço" 
                                            as={Input}
                                        />
                                        <Field 
                                            id="district" 
                                            name="district"
                                            autoComplete="district"
                                            className="inputCustom" 
                                            isError={errorOnSubmit && errors.district}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                handleChange(e);
                                                setCepDetail({...cepDetail, bairro: e.target.value})
                                            }}
                                            placeholder="Bairro" 
                                            as={Input}
                                        />
                                        <Field 
                                            id="number" 
                                            name="number" 
                                            autoComplete="number"
                                            className="inputCustom" 
                                            isError={errorOnSubmit && errors.number}
                                            placeholder="Número" 
                                            as={Input}
                                        />
                                        <Field 
                                            id="complement" 
                                            autoComplete="complement" 
                                            name="complement" 
                                            className="inputCustom" 
                                            placeholder="Complemento" 
                                            as={Input}
                                        />
                                    </Fieldset>
                                </BoxInputs>

                                { notifysFieldsForm(errors, errorOnSubmit) }

                                { 
                                    errorOnReturnApi 
                                        && errorOnSubmit
                                        && <ErrorMessage>
                                            Erro ao cadastrar cliente
                                        </ErrorMessage>
                                }
                                <Button
                                    id="button-submit"
                                    type="submit"
                                    className="buttonCustom"
                                    onClick={() => {
                                        searchForErrors(errors, setErrorOnSubmit);
                                        toastCreate("btnSubmit", "info", 3000, "Processando")
                                    }}
                                >
                                Adicionar
                                </Button>
                            </Form>
                        </ContainerFormSide>
                    )
                }}
                </Formik>
            </SideForm>
        </SideContainerAnimated>
    )
}

export default FormAddClient